
export const _coachingSeasonClass = {
  name: { type: 'string', title: 'Nimi' },
  classes: { type: 'array', title: 'Valmennuskokonaisuudet', items: { type: 'string', oneOf: [] } },
  start: { type: 'string', format: 'date', title: 'Alkaa' },
  end: { type: 'string', format: 'date', title: 'Loppuu' },
  description: { type: 'string', title: 'Kuvaus' },
  entrystart: { type: 'string', format: 'date', title: 'Ilmoittautuminen alkaa' },
  entryend: { type: 'string', format: 'date', title: 'Ilmoittautuminen päättyy' },
  applicationid: { type: 'string', title: 'Ilmoittautumislomake' },
  replacement:{ type: 'object', title: 'Korvausjärjestelmä', properties: {
    enabled: { type: 'boolean', title: 'Käytössä' },
    maxreplacements: { type: 'number', title: 'Maksimi korvauskerrat', help: 'Montako korvaustuntia osallistuja voi tallentaa per kausi' },
    maxlevel: { type: 'number', title: 'Maksimi taso' },
    minlevel: { type: 'number', title: 'Minimi taso' },
    storingtimeline: { type: 'number', title: 'Montako tuntia ennen voi tunnin tallentaa' },
    cancellingtimeline: { type: 'number', title: 'Montako tuntia ennen varatun korvaustunnin saa perua' },
  }},
  state: {
    type: 'string',
    title: 'Tila',
    oneOf: [
      { const: 'draft', title: 'Luonnos' },
      { const: 'active', title: 'Aktiivinen/Lukittu' },
      { const: 'archived', title: 'Arkistoitu' },
      { const: 'deleted', title: 'Poistettu' },
    ],
  }
}

export const _coachingSeasonUISchema = {}

export const _coachingClassClass = {
  name: { type: 'string', title: 'Nimi' },
  description: { type: 'string', title: 'Kuvaus' }, 
  minage: { type: 'number', title: 'Osallistujan minimi ikä' },
  maxage: { type: 'number', title: 'Osallistujan maksimi ikä' },
  maxparticipants: { type: 'number', title: 'Maksimi osallistujamäärä' },
  termsid: { type: 'string', title: 'Ehdot' },
  state: {
    type: 'string',
    title: 'Tila',
    oneOf: [
      { const: 'draft', title: 'Luonnos' },
      { const: 'active', title: 'Aktiivinen' },
      { const: 'archived', title: 'Arkistoitu' },
      { const: 'deleted', title: 'Poistettu' },
    ],
  },
  pricingid: { type: 'string', title: 'Hinnoittelu' },
  breaks: { type: 'array', title: 'Tauot', items: { type: 'string' } },
  applicationid: { type: 'string', title: 'Ilmoittautuminen' },
}
export const _coachingClassUISchema = {}

export const _coachingBreakClass = {
  name: { type: 'string', title: 'Nimi' },
  start: { type: 'string', format: 'date', title: 'Alkupäivä' },
  end: { type: 'string', format: 'date', title: 'Loppupäivä' },
}

export const _coachingBreakUISchema = {}

export const _coachingLevelClass = {
  name: { type: 'string', title: 'Nimi' },
  abbr: { type: 'string', title: 'Lyhenne' },
  description: { type: 'string', title: 'Kuvaus' },
  order: { type: 'number', title: 'Järjestysluku', help: 'Mitä suurempi luku, sitä ylempänä taso on' },
}

export const _coachingLevelUISchema = {}

export const _coachingApplicationClass = {
  name: { type: 'string', title: 'Nimi' },
  description: { type: 'string', title: 'Kuvaus' },
  fields: { type: 'array', title: 'Kentät', items: { type: 'string' } },
}
export const _coachingApplicationUISchema = {}

export const _coachingFieldClass = {
  name: { type: 'string', title: 'Nimi' },
  type: {
    type: 'string',
    title: 'Tyyppi',
    oneOf: [
      { const: 'string', title: 'Teksti' },
      { const: 'number', title: 'Numero' },
      { const: 'date', title: 'Päivämäärä' },
      { const: 'boolean', title: 'Kyllä/Ei' },
      { const: 'select', title: 'Valinta' },
    ],
  },
  required: { type: 'boolean', title: 'Pakollinen' },
  options: { type: 'array', title: 'Valinnat (vain valinta tyyppi)', items: { type: 'string' } },
}
export const _coachingFieldUISchema = {}

export const _coachingPricingClass = {
  class: { type: 'string', title: 'Valmennuskokonaisuus / Joukkue' },
  season: { type: 'string', title: 'Kausi' },
  price: { type: 'number', title: 'Hinta (€)' },
  priceunit: { type: 'string', title: 'Hinta yksikkö', oneOf: [{ const: 'perhour', title: 'Per tunti' }, { const: 'per season', title: 'Per kausi' }] },
  steps: {
    type: 'array', title: 'Maksuportaat', items: {
      type: 'object', properties: {
        type: { type: 'string', title: 'Tyyppi', oneOf: [{ const: 'groupsize', title: 'Ryhmänkoko' }, { const: 'timesperweek', title: 'Viikkotuntien määrä' }] },
        value: { type: 'number', title: 'Arvo' },
        price: { type: 'number', title: 'Hinta (€)' },
      },
    },
  },

}
export const _coachingPricingUISchema = {}
